import { Component, ElementRef, Input, TemplateRef, ViewChild } from '@angular/core';
import { AppService } from '../../app.service';
import { messageService } from '../../message.service';
import { PaginationService } from '../../PaginationService';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { SuccessSnackbarComponent } from '../success-snackbar/success-snackbar.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
import { qmsService } from '../../qms/qms.service';

export interface PopupData {
  title: string;
}

@Component({
  selector: 'app-excel-pdf',
  templateUrl: './excel-pdf.component.html',
  styleUrls: ['./excel-pdf.component.scss']
})

export class ExcelPdfComponent {
  isProcessing: boolean = false;
  @Input() excelPdf: any = {};
  isSaveReport: boolean = false;
  reportName: any;
  checkAuVw: boolean = false;
  selectedReportFooter: any;
  reportFooterDropdown1: any = [];
  reportFooterDropdown: any = [];
  reportFooterFieldValidation: any;
  pdfDetailSearchText: string = '';
  constructor(private appService: AppService, public qmsservices: qmsService, public paginationService: PaginationService, public message: messageService, private elem: ElementRef, public dialog: MatDialog, private snackBar: MatSnackBar) { }

  @ViewChild('excelPdfPopup', { static: true }) excelPdfPopup: TemplateRef<any>;
  visibleExcelPdfPopup: MatDialogRef<TemplateRef<any>>;

  columnSearchText: string = '';

  focusSearch(value: any) {
    setTimeout(() => {
      let searchBox = document.getElementById(value);
      searchBox?.focus();
    }, 0)
  }


  excelPdfPopupConfig = {
    width: '700px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  }

  multiSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: true,
    allowSearchFilter: false,
    singleSelection: false,
    itemsShowLimit: 3,
  };

  selectedColumns: any = [];
  dropDownForReport: any;
  isForExcel: boolean = false;
  popupDataTitle: PopupData = { title: '' };
  pdfPageSizes: any = [];
  openReportPopup(item: any) {
    this.reportFooterDropdown = [];
    this.ngOnChangesReportFooter();
    this.pdfPageSizes = JSON.parse(sessionStorage.getItem('pdfPageSizes') || '{}');
    this.excelPdf.pdfPageSize = 'A4';
    this.excelPdf.dropDown = this.excelPdf.dropDown?.map((data: any) => ({ valueExp: data, displayExp: data }));
    this.isForExcel = item == 'Excel';
    this.excelPdf.manualEntryDataFields = this.excelPdf.manualEntryDataFields;
    this.popupDataTitle.title = item == 'Excel' ? 'Excel Report' : 'PDF Report';
    [this.manuallyPicked, this.maxCountReached, this.selectedColumns] = [false, false, []];

    console.log("this.excelPdf.reportObj", this.excelPdf.reportObj);
    if (this.excelPdf.reportObj) {
      if (this.excelPdf.reportObj.tableOrViewName == 'QMS_AU_SCHEDULE_VW' || this.excelPdf.reportObj.tableOrViewName == 'QMS_AU_PLAN_VW' || this.excelPdf.reportObj.tableOrViewName == 'QMS_AU_CONDUCT_VW') {
        this.checkAuVw = true;
      } else {
        this.checkAuVw = false;
      }
    } else {
      this.checkAuVw = false;
    }

    const timestamp = Date.now();
    const formattedDate = new Intl.DateTimeFormat('en-US', {
      day: '2-digit', month: 'short', year: 'numeric',
    }).format(new Date(timestamp)).replace(/[, ]/g, (match) => match === ',' ? '' : '_');
    this.reportName = this.excelPdf.reportName + "_" + formattedDate;
    this.visibleExcelPdfPopup = this.dialog.open(this.excelPdfPopup, this.excelPdfPopupConfig);
    this.isSaveReport = false;
  }

  cancelReportPopup() {
    this.visibleExcelPdfPopup.close();
    [this.manuallyPicked, this.maxCountReached, this.selectedColumns] = [false, false, []];
  }

  manuallyPicked: boolean;
  onCheckboxChange(event: MatSlideToggleChange) {
    if (!event.checked) {
      [this.manuallyPicked, this.maxCountReached, this.selectedColumns] = [false, false, []];
    }
  }

  isReportNameEmpty = false;

  generateReport(value: any, reportType: any) {


    if (this.manuallyPicked && !this.selectedColumns.length) {
      this.showSnackBar('Please select the Columns', 'E');
    } else if (value === 'Pdf' && this.manuallyPicked && this.selectedColumns.length > 12) {
      this.showSnackBar('Selected columns exceeded the limit. Limit 12, Selected ' + this.selectedColumns.length, 'E');
    } else if (this.isSaveReport && !this.reportName?.trim()) {
      this.isReportNameEmpty = true;
      this.showSnackBar('Please enter the Report Name', 'E');

    } else {
      reportType === 'Dynamic' && this.dynamicReport(value);
      reportType === 'Static' && this.staticReport(value);
    }
  }


  dynamicReport(value: any) {
    const timestamp = Date.now();
    const formattedDate = new Intl.DateTimeFormat('en-US', {
      day: '2-digit', month: 'short', year: 'numeric',
    }).format(new Date(timestamp)).replace(/[, ]/g, (match) => match === ',' ? '' : '_');

    let fileType = value == 'Excel' ? 'xlsx' : 'pdf';
    const fileName = `${this.excelPdf.reportName}_${formattedDate}.${fileType}`;

    if (value == 'Excel') {
      const excelData = {
        ...this.excelPdf.reportObj, title: this.excelPdf.reportName, columns: this.manuallyPicked ? this.selectedColumns.join(',') : this.excelPdf.dropDown?.map((excelPdf: any) => excelPdf.valueExp).join(','), pdfPageSize: this.excelPdf.pdfPageSize,
        "informationTab": { "Report Name": this.excelPdf.reportName, "Exported By": sessionStorage.getItem("reportsUserName") }
      }
      this.downloadExcelReport(excelData, fileName);
    } else {
      console.log("this.excelPdf.reportObj=", this.excelPdf.reportObj);

      let pdfData;
      if (this.excelPdf.reportObj) {
        if (this.excelPdf.reportObj.tableOrViewName == "QMS_AU_SCHEDULE_VW" || this.excelPdf.reportObj.tableOrViewName == "QMS_AU_PLAN_VW" || this.excelPdf.reportObj.tableOrViewName == "QMS_AU_CONDUCT_VW") {
          pdfData = {
            ...this.excelPdf.reportObj, manualEntryDataFields: this.excelPdf.manualEntryDataFields ?? null, "footer": this.selectedReportFooter, title: this.excelPdf.reportName, columns: this.manuallyPicked ? this.selectedColumns.join(',') : this.excelPdf.dropDown?.map((excelPdf: any) => excelPdf.valueExp).slice(0, 10).join(','), logoId: 0, isSaveRep: this.isSaveReport ? 'Y' : 'N', reportName: this.reportName ?? "", currentStatus: "NA", groupName: "NA", pdfPageSize: this.excelPdf.pdfPageSize
          }
        } else {
          pdfData = {
            ...this.excelPdf.reportObj, manualEntryDataFields: this.excelPdf.reportObj.manualEntryDataFields ?? null, "footer": this.selectedReportFooter, title: this.excelPdf.reportName, columns: this.manuallyPicked ? this.selectedColumns.join(',') : this.excelPdf.dropDown?.map((excelPdf: any) => excelPdf.valueExp).slice(0, 10).join(','), logoId: 0, isSaveRep: 'N', pdfPageSize: this.excelPdf.pdfPageSize
          }
        }
      } else {
        pdfData = {
          ...this.excelPdf.reportObj, manualEntryDataFields: this.excelPdf.reportObj.manualEntryDataFields ?? null, "footer": this.selectedReportFooter, title: this.excelPdf.reportName, columns: this.manuallyPicked ? this.selectedColumns.join(',') : this.excelPdf.dropDown?.map((excelPdf: any) => excelPdf.valueExp).slice(0, 10).join(','), logoId: 0, isSaveRep: 'N', pdfPageSize: this.excelPdf.pdfPageSize,
        }
      }
      this.downloadPdfReport(pdfData, fileName);
    }
  }

  staticReport(value: any) {
    const primary_obj = {
      groupId: null, "footer": this.selectedReportFooter
    }

    let $DB = this.excelPdf.columnList_DB.split(',');
    const columnsToRemoveFrom_DB = ['DOC', 'TEMPLATE', 'DOCUMENT', 'LOGIN_IMAGE', 'LOGO_IMAGE', 'REPORT_IMAGE', 'TRAINING_IMAGE'];

    columnsToRemoveFrom_DB.forEach(column => {
      let index = $DB.indexOf(column);
      if (index !== -1) {
        $DB.splice(index, 1);
      }
    });
    this.excelPdf.columnList_DB = $DB.join(',');

    console.log('DB', this.excelPdf.columnList_DB);

    let $UI = this.excelPdf.columnList_Report.split(',');

    const columnsToRemoveFrom_Report = ['Document', 'Template', 'Login Image', 'Logo Image', 'Report Image', 'Training Image'];

    columnsToRemoveFrom_Report.forEach(column => {
      let index = $UI.indexOf(column);
      if (index !== -1) {
        $UI.splice(index, 1);
      }
    });
    this.excelPdf.columnList_Report = $UI.join(',');

    console.log('UI', this.excelPdf.columnList_Report);

    const secondary_obj: any = {
      tableOrViewName: this.excelPdf.tableOrView_Name, columnsList: this.excelPdf.columnList_DB, fieldLabelsList: this.excelPdf.columnList_Report,
      invisibleColumn: "", orderByClause: this.excelPdf.orderByClause, fieldSizeList: "",
      columnsListarray: [], fieldColumnarray: [], invisibleColumnarray: [], fieldSizeListArray: [],
      codelistGroup: null, manualEntryDataFields: this.excelPdf.manualEntryDataFields ?? null, groupId: null, chartStatus: null,
      wherVal: this.excelPdf.whereClause_Report, reModule: "tms"
    }

    const timestamp = Date.now();
    const formattedDate = new Intl.DateTimeFormat('en-US', {
      day: '2-digit', month: 'short', year: 'numeric',
    }).format(new Date(timestamp)).replace(/[, ]/g, (match) => match === ',' ? '' : '_');

    const extension = value == 'Excel' ? 'xlsx' : 'pdf';

    if (value == 'Excel') {
      let excel_data;
      if (this.excelPdf.tableOrView_Name) {
        if (this.excelPdf.tableOrView_Name == "ONEQMS_FORM_SECTION_DATA_VW") {
          excel_data = {
            ...primary_obj, ...secondary_obj, title: this.excelPdf.reportName, columns: this.manuallyPicked ? this.selectedColumns.join(',') : this.excelPdf.dropDown?.map((excelPdf: any) => excelPdf.valueExp).join(','), templateId: this.excelPdf.templateId, sectionId: this.excelPdf.sectionId, orderByClause: "RECORD_SEQ",
            "informationTab": { "Report Name": this.excelPdf.reportName, "Exported By": sessionStorage.getItem("reportsUserName") }
          }
        } else {
          excel_data = {
            ...primary_obj, ...secondary_obj, title: this.excelPdf.reportName, columns: this.manuallyPicked ? this.selectedColumns.join(',') : this.excelPdf.dropDown?.map((excelPdf: any) => excelPdf.valueExp).join(','),
            "informationTab": { "Report Name": this.excelPdf.reportName, "Exported By": sessionStorage.getItem("reportsUserName") }
          }
        }
      } else {
        excel_data = {
          ...primary_obj, ...secondary_obj, title: this.excelPdf.reportName, columns: this.manuallyPicked ? this.selectedColumns.join(',') : this.excelPdf.dropDown?.map((excelPdf: any) => excelPdf.valueExp).join(','),
          "informationTab": { "Report Name": this.excelPdf.reportName, "Exported By": sessionStorage.getItem("reportsUserName") }
        }
      }
      console.log("excel_data=", excel_data)
      this.downloadReport('Excel', excel_data, `${this.excelPdf.reportName.replaceAll(" ", "_")}_${formattedDate}.${extension}`);

    } else {
      console.log(this.excelPdf.sectionId, "=====this.excelPdf.reportObj.sectionId");
      let pdf_data;
      if (this.excelPdf.reportObj) {
        if (this.excelPdf.reportObj.tableOrViewName == "QMS_AU_SCHEDULE_VW" || this.excelPdf.reportObj.tableOrViewName == "QMS_AU_PLAN_VW" || this.excelPdf.reportObj.tableOrViewName == "QMS_AU_CONDUCT_VW") {
          pdf_data = {
            ...primary_obj, ...secondary_obj, title: this.excelPdf.reportName, columns: this.manuallyPicked ? this.selectedColumns.join(',') : this.excelPdf.dropDown?.map((excelPdf: any) => excelPdf.valueExp).slice(0, 10).join(','), logoId: 0, isSaveRep: this.isSaveReport ? 'Y' : 'N', reportName: this.reportName ?? "", currentStatus: "NA", groupName: "NA", pdfPageSize: this.excelPdf.pdfPageSize
          }
        } else {
          pdf_data = {
            ...primary_obj, ...secondary_obj, title: this.excelPdf.reportName, columns: this.manuallyPicked ? this.selectedColumns.join(',') : this.excelPdf.dropDown?.map((excelPdf: any) => excelPdf.valueExp).slice(0, 10).join(','), logoId: 0, isSaveRep: 'N', pdfPageSize: this.excelPdf.pdfPageSize
          }
        }
      } else if (this.excelPdf.tableOrView_Name == "ONEQMS_FORM_SECTION_DATA_VW") {
        pdf_data = {
          ...primary_obj, ...secondary_obj, templateId: this.excelPdf.templateId, sectionId: this.excelPdf.sectionId, orderByClause: "RECORD_SEQ", title: this.excelPdf.reportName, columns: this.manuallyPicked ? this.selectedColumns.join(',') : this.excelPdf.dropDown?.map((excelPdf: any) => excelPdf.valueExp).slice(0, 10).join(','), logoId: 0, isSaveRep: 'N', pdfPageSize: this.excelPdf.pdfPageSize
        }
      } else {
        pdf_data = {
          ...primary_obj, ...secondary_obj, title: this.excelPdf.reportName, columns: this.manuallyPicked ? this.selectedColumns.join(',') : this.excelPdf.dropDown?.map((excelPdf: any) => excelPdf.valueExp).slice(0, 10).join(','), logoId: 0, isSaveRep: 'N', pdfPageSize: this.excelPdf.pdfPageSize
        }
      }

      console.log("pdf_data=", pdf_data)
      this.downloadReport('Pdf', pdf_data, `${this.excelPdf.reportName.replaceAll(" ", "_")}_${formattedDate}.${extension}`);
    }
  }

  downloadReport(downloadAs: string, data: any, fileName: string) {
    if (downloadAs == 'Excel') {
      this.isProcessing = true;
      this.appService.downloadexceWithColumnchooser(data).subscribe({
        next: (content: any) => {
          let dataType = content.type;
          let binaryData = [];
          binaryData.push(content);
          let downloadLink = document.createElement('a');
          downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, { type: dataType }));
          if (fileName)
            downloadLink.setAttribute('download', fileName);
          document.body.appendChild(downloadLink);
          downloadLink.click();
          this.isProcessing = false;
        },
        error: (error) => {
          this.isProcessing = false;
          throw error;
        }
      })
    } else {
      this.isProcessing = true;
      this.appService.downloadPdfFile(data).subscribe({
        next: (content: any) => {
          let dataType = content.type;
          let binaryData = [];
          binaryData.push(content);
          let downloadLink = document.createElement('a');
          downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, { type: dataType }));
          if (fileName)
            downloadLink.setAttribute('download', fileName);
          document.body.appendChild(downloadLink);
          downloadLink.click();
          this.isProcessing = false;
        },
        error: (error) => {
          this.isProcessing = false;
          throw error;
        }
      })
    }
  }

  downloadDocument(list: any) {
    console.log(list);
    let contentData = "data:application/octet-stream;base64," + list.TEMPLATE;
    let downloadLink = document.createElement("a");
    downloadLink.href = contentData;
    downloadLink.download = list.TEMPLATE_NAME + "." + list.TEMPLATE_EXTN;
    downloadLink.click();
  }

  maxCountReached: boolean = false;
  selectedColumnsAsString: string = "";
  @ViewChild('columns') columns: MatSelect;
  isAllColumns = false;

  toggleAllSelection(value: any) {
    if (value == 'columns') {
      if (this.isAllColumns) this.columns.options.forEach((item: MatOption) => item.select());
      else {
        this.columns.options.forEach((item: MatOption) => item.deselect())
        this.selectedColumns = [];
      }
      setTimeout(() => {
        if (this.selectedColumns.length > 10) this.maxCountReached = true; else this.maxCountReached = false;
        this.convertArrayToString(this.selectedColumns);
      });
    }
  }

  onColumnSelect(event: any, item: any) {
    if (event.isUserInput) {
      setTimeout(() => {
        if (this.selectedColumns.length > 10) this.maxCountReached = true; else this.maxCountReached = false;
        this.convertArrayToString(this.selectedColumns);
        this.isAllColumns = this.selectedColumns.length == this.excelPdf.dropDown.length;
      });
    }
  }

  onSelect() {
    if (this.selectedColumns.length > 10) this.maxCountReached = true; else this.maxCountReached = false;
    this.convertArrayToString(this.selectedColumns);
  }

  onDeSelect() {
    this.onSelect();
  }

  onSelectAll(item: any[]) {
    if (item.length > 10) this.maxCountReached = true; else this.maxCountReached = false;
    this.convertArrayToString(item);
  }

  onDeSelectAll(item: any[]) {
    if (item.length > 10) this.maxCountReached = true; else this.maxCountReached = false;
    this.convertArrayToString(item);
  }

  convertArrayToString(array: any) {
    this.selectedColumnsAsString = array.join(', ');
  }

  showSnackBar(message: string, type: string) {
    const sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Error',
        buttonLabel: 'Ok',
        pageName: this.message.breadcrumbData.thirdLevel ?? this.message.breadcrumbData.secondLevel,
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });

    sb.onAction().subscribe(() => {
      sb.dismiss();
    });
  }

  downloadExcelReport(data: any, fileName: string) {

    this.isProcessing = true;
    this.appService.downloadexceWithColumnchooser(data).subscribe(
      (response: any) => {
        let dataType = response.type;
        let binaryData = [];
        binaryData.push(response);
        let downloadLink = document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, { type: dataType }));
        if (fileName)
          downloadLink.setAttribute('download', fileName);
        document.body.appendChild(downloadLink);
        downloadLink.click();
        this.isProcessing = false;
      },
      (error) => {
        this.isProcessing = false;
        throw error;
      })
  }

  downloadPdfReport(pdfData: any, fileName: string) {

    this.isProcessing = true;
    this.appService.downloadPdf(pdfData).subscribe(
      (response: any) => {
        let dataType = response.type;
        let binaryData = [];
        binaryData.push(response);
        let downloadLink = document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, { type: dataType }));
        if (fileName)
          downloadLink.setAttribute('download', fileName);
        document.body.appendChild(downloadLink);
        downloadLink.click();
        this.isProcessing = false;
      },
      (error) => {
        this.isProcessing = false;
        throw error;
      })
  }
  //this.reportLogoDropdown = [];
  onReportFooterSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (this.reportFooterFieldValidation != undefined) {
        this.reportFooterFieldValidation.style.color = '#005c8a';
      }
    }
  }

  ngOnChangesReportFooter() {
    this.isProcessing = true;
    this.appService.getCodeListsByGroup("REPORT_FOOTER").subscribe(
      (data: any) => {
        this.reportFooterDropdown1 = data;
        console.log("data", this.reportFooterDropdown1);
        this.selectBoxForFooter();
        if (this.reportFooterDropdown.length > 0) {
          this.selectedReportFooter = this.reportFooterDropdown[0].valueExp;
        }

        this.isProcessing = false;
      },
      (error: any) => {
        this.isProcessing = false;
      }
    );
  }


  selectBoxForFooter() {
    this.reportFooterDropdown = [];
    for (const vals of this.reportFooterDropdown1) {

      if (vals.moduleList == "Common" || vals.moduleList.includes(this.qmsservices.moduleName)) {
        this.reportFooterDropdown.push({
          valueExp: vals.codelistName,
          displayExp: vals.codelistName
        });
      }

    }
  }

}
